module.exports = __webpack_public_path__ + "static/media/B2.116d26b3.jpg";